import Browser from '@wetransfer/concorde-browser';

import DIRECTORIES_SELECTION_STATES from '@app/constant/directories-selection-states';

export function getDirectoriesSelectionState() {
  if (Browser.isMobile) {
    return DIRECTORIES_SELECTION_STATES.NONE;
  }

  // Safari can select files and folders simultaneously
  if (Browser.matches('safari')) {
    return DIRECTORIES_SELECTION_STATES.COMBINED;
  }

  return DIRECTORIES_SELECTION_STATES.SEPARATED;
}
